const JOB = 'job';
const POSITION = 'position';
const USER = 'user';

export default {
  JOB,
  POSITION,
  USER,
};
